__turbopack_context__.v({
  "icon": "styles-module-scss-module__yd3WiW__icon",
  "validationText": "styles-module-scss-module__yd3WiW__validationText",
});
